var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKsLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Katalon Studio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Invite-users-to-your-organization",
    transform: "translate(-367.000000, -476.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-KS-Copy",
    transform: "translate(367.000000, 476.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#9DCC3D",
    points: "0 34.9483817 13.1203482 34.9483817 34.9888393 0.17922247 0 0.17922247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#67B240",
    points: "34.9888393 34.9483817 13.3321243 34.9483817 7.77529762 26.0747761 20.530593 12.0079055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35193452,8.78190104 L24.1629464,8.78190104 C24.6765718,8.78190104 25.093006,9.1958059 25.093006,9.70631168 L25.093006,25.4212925 C25.093006,25.9317983 24.6765718,26.3457031 24.1629464,26.3457031 L8.35193452,26.3457031 C7.83830915,26.3457031 7.421875,25.9317983 7.421875,25.4212925 L7.421875,9.70631168 C7.421875,9.1958059 7.83830915,8.78190104 8.35193452,8.78190104",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.791169,20.1599973 C17.791169,18.392792 12.0623243,19.4978276 12.0623243,15.4446111 C12.0623243,13.6861591 13.7874698,12.0079055 16.4161587,12.0079055 C19.2089735,12.0079055 20.4412551,13.6061972 20.4412551,13.6061972 L19.0684332,15.7930841 C18.9534235,15.6364723 18.811181,15.4786777 18.6421921,15.3199368 C18.6421921,15.3199368 17.8782165,14.5655034 16.7446537,14.5655034 C16.0054793,14.5655034 15.2692227,14.8472626 15.2692227,15.524573 C15.2692227,17.0431393 20.8519345,16.2437569 20.8519345,20.1599973 C20.8519345,22.1580984 19.1270322,23.8365885 16.2517897,23.8365885 C14.0493418,23.8365885 12.6346982,22.8292579 12.016369,22.2744927 C12.016369,22.2744927 12.476651,21.5430069 13.3969717,20.0800354 C13.3969717,20.0800354 14.4447028,21.2789907 15.9232947,21.2789907 C16.9698101,21.2789907 17.791169,20.9532288 17.791169,20.1599973",
    id: "Fill-5",
    fill: "#67B240"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsLogoBig);
export default __webpack_public_path__ + "static/media/KS_logo_big.3f9b4e449a1e3683953e0de425351d18.svg";
export { ForwardRef as ReactComponent };